import './order-info.less';
import Inputmask from 'inputmask';

$(function () {
    var initOrederInfo = function () {
        var formName = 'OrderRequestForm';
        var elements = {};

        elements['#' + formName + '_ID'] = {
            elements: [
                '#' + formName + '_PHONE',
                '#' + formName + '_EMAIL',
                '#' + formName + '_IDPROBLEM',
            ],
            empty: '',
        };
        elements['#' + formName + '_IDPROBLEM'] = {
            elements: ['#' + formName + '_PHONE', '#' + formName + '_EMAIL'],
            empty: '',
        };
        elements['#' + formName + '_PHONE'] = {
            elements: [
                '#' + formName + '_ID',
                '#' + formName + '_IDPROBLEM',
                '#' + formName + '_EMAIL',
            ],
            empty: '+7 (___) ___-____',
        };
        elements['#' + formName + '_EMAIL'] = {
            elements: [
                '#' + formName + '_PHONE',
                '#' + formName + '_ID',
                '#' + formName + '_IDPROBLEM',
            ],
            empty: '',
        };

        var formDisabler = function (
            mainElement,
            elementsForDisable,
            emptyTemplate
        ) {
            var emptyValue = emptyTemplate || '';
            var value = $(mainElement).val();
            var isDisabled = true;

            if (value === emptyValue) {
                isDisabled = false;
            }

            for (var i = 0; i < elementsForDisable.length; i++) {
                $(elementsForDisable[i]).attr('disabled', isDisabled);
            }
        };

        for (var elementId in elements) {
            if ($(elementId).length > 0 && $(elementId).val() !== '') {
                formDisabler(
                    elementId,
                    elements[elementId].elements,
                    elements[elementId].empty
                );
            }

            $(elementId).keyup(function () {
                var elementId = '#' + $(this).attr('id');
                formDisabler(
                    elementId,
                    elements[elementId].elements,
                    elements[elementId].empty
                );
            });
        }
    };

    $('#order_info_link').click(function (e) {
        e.preventDefault();

        $.ajax({
            url: $(this).attr('href'),
            success: function (data) {
                $('#order_info_container').html(data);
                $('#order_info_popup').show();

                $('.phone-mask').each(function () {
                    Inputmask($(this).attr('data-mask')).mask(this);
                    $(this).on('paste', hendlerPastePhoneMask);
                    $(this).on('click', masked_selected_text);
                });

                initOrederInfo();
            },
        });
    });

    $(document).mouseup(function (e) {
        var container = $('#order_info_popup');

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            container.hide();
        }
    });
    var masked_selected_text = function () {
        $(this).select();
    };

    var hendlerPastePhoneMask = function (e) {
        var regex = /^((8|7|\+7)[\- ]?)/gm; // eslint-disable-line
        var pastedData, match;

        if (window.clipboardData && window.clipboardData.getData) {
            // fix ie
            pastedData = window.clipboardData.getData('Text');
        } else if (
            e.originalEvent.clipboardData &&
            e.originalEvent.clipboardData.getData
        ) {
            // other
            pastedData = e.originalEvent.clipboardData.getData('text/plain');
        }

        if ((match = regex.exec(pastedData) && pastedData)) {
            $(this).val(pastedData.replace(match[0], ''));
            e.stopPropagation();
            e.preventDefault();
            return false;
        }
    };
});
